import { useSettings } from '@wix/tpa-settings/react';
import { FormType } from '../../../types/types';
import loginSettingsParams from '../../Login/settingsParams';
import signupSettingsParams from '../../Signup/settingsParams';
import { ISettingsParam, SettingsParamType } from '@wix/tpa-settings';

export interface DividerSettings {
  dividerText: ISettingsParam<SettingsParamType.Text, string>;
}

const PARAMS: Record<FormType, DividerSettings> = {
  login: loginSettingsParams,
  signup: signupSettingsParams,
};

interface UseDividerSettingsParams {
  formType: FormType;
}

export const useDividerSettings = ({ formType }: UseDividerSettingsParams) => {
  const settings = useSettings();

  if (!(formType in PARAMS)) {
    return {};
  }

  const settingsParams = PARAMS[formType];

  const dividerText = settings.get(settingsParams.dividerText);

  return { dividerText };
};
